/** Where the program-settings form goes when the user closes it. */
export enum IntakeLeaveTarget {
  /** a page sits beneath the form, so go back to it exactly as before */
  PopToPrevious = 'pop-to-previous',
  /** the form is the only page in the stack, so open Program Settings in its place */
  ProgramSettings = 'program-settings',
}

/**
 * Decide how the program-settings form (the intake form in change mode) is left.
 *
 * The form can be the ONLY page in the stack. A link tapped on the phone opens it that
 * way, and so does the next relaunch, which restores the address that link wrote
 * (df-0af813f77a05, support #3832). Popping the bottom of the stack does not go back.
 * It becomes a browser back with nowhere to go, which either leaves the user on the form
 * or lands on an unrelated older page. `BrowserHistory.navigateBackAsync` in
 * `browser-history.ts` explains why. So with nothing beneath, the form opens Program
 * Settings, the page it is normally reached from. `send-feedback.ts` and `edit-food.ts`
 * make the same choice for the same reason.
 */
export function decideIntakeLeaveTarget(canGoBack: boolean): IntakeLeaveTarget {
  return canGoBack ? IntakeLeaveTarget.PopToPrevious : IntakeLeaveTarget.ProgramSettings;
}
